import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import types from './types';

const actions = {
  async getEmails({ commit }) {
    try {
      commit(types.GET_EMAILS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.emailTemplates}`,
        isToken: true,
      });
      commit(types.GET_EMAILS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_EMAILS_FAILURE, message);
    }
  },
  async createEmail({ dispatch }, data) {
    try {
      await apiCall({
        type: 'POST',
        url: `${URLS.emailTemplates}`,
        body: data,
        isToken: true,
      });
      notificationWithIcon('success', 'Email created');
      dispatch('getEmails');
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async copyEmail({ dispatch }, { id, forCustomerCategoryId }) {
    try {
      await apiCall({
        type: 'POST',
        url: `${URLS.emailTemplates}/copy/${id}`,
        body: { forCustomerCategoryId },
        isToken: true,
      });
      notificationWithIcon('success', 'Email copied');
      dispatch('getEmails');
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async changeEmail({ dispatch }, body) {
    try {
      const { id, ...restValues } = body;
      await apiCall({
        type: 'PUT',
        url: `${URLS.emailTemplates}/${id}`,
        body: restValues,
        isToken: true,
      });
      notificationWithIcon('success', 'Email updated');
      dispatch('getEmails');
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteEmail({ dispatch }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.emailTemplates}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Email deleted');
      dispatch('getEmails');
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async getPreviewEmail({ commit }, body) {
    try {
      commit(types.RESET_EMAIL_PREVIEW);
      const { data: { data } } = await apiCall({
        type: 'POST',
        url: `${URLS.sendEmail}`,
        body,
        isToken: true,
      });
      commit(types.GET_EMAIL_PREVIEW_SUCCESS, data);
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
      commit(types.RESET_EMAIL_PREVIEW);
    }
  },
  async clearPreviewEmail({ commit }) {
    commit(types.RESET_EMAIL_PREVIEW);
  },
  async sendPreviewEmail(_, body) {
    try {
      await apiCall({
        type: 'POST',
        url: `${URLS.sendEmailPreview}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Email sended');
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async uploadEmailImage({ commit }, file) {
    try {
      const { data } = await apiCall({
        type: 'POST',
        headers: { 'content-type': 'multipart/form-data' },
        url: `${URLS.fileUpload}`,
        body: file,
        isToken: true,
      });
      commit(types.UPLOAD_EMAIL_IMAGE_SUCCESS, data);
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async clearEmailImage({ commit }) {
    commit(types.CLEAR_EMAIL_IMAGE);
  },
};

export default actions;
